import { Form, Button, Spin } from "antd";
import { useIncentiveSlab } from "./store";
import RenderFilterFields from "./RenderFilterFields";

const IncentiveSlabFilter = ({
  onClose,
  onApplyFilters,
  setQueryParam,
  setCurrentPage,
  setPageSize,
  setTriggerFetch,
}) => {
  const { incentiveSlabFilterData, incentiveSlabFilterDataLoading } =
    useIncentiveSlab();

  const [form] = Form.useForm();

  const handleFieldChange = (fieldCode, value) => {
    form.setFieldsValue({ [fieldCode]: value });
  };

  const handleFinish = (values) => {
    onApplyFilters(values);
    onClose();
  };

  const handleClear = () => {
    form.resetFields();
    const initialQueryParam = {
      pageSize: 10,
      pageNumber: 1,
    };
    setQueryParam(initialQueryParam);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
    onClose();
  };

  return (
    <Spin spinning={incentiveSlabFilterDataLoading}>
      <Form layout="vertical" onFinish={handleFinish} form={form}>
        <RenderFilterFields
          filtersData={incentiveSlabFilterData.filters}
          onFieldChange={handleFieldChange}
        />

        <div className="d-flex justify-content-between">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={handleClear}>Clear</Button>
        </div>
      </Form>
    </Spin>
  );
};

export default IncentiveSlabFilter;
